import axios from 'axios';
import { API_URL, API_URL_M7, getCachedSessionId } from '../services/common';

export const api = axios.create({
  baseURL: API_URL,
  headers: { 'x-session-id': getCachedSessionId() }
});

export const apiM7 = axios.create({
  baseURL: API_URL_M7,
  headers: { 'x-session-id': getCachedSessionId() }
});
